import businessClient from 'src/services/clients/business'
import { IMeta, IStockControl, IAdjustmentInfo } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { list: [IStockControl] } }
const IAdjustmentInfoResponse = { meta: IMeta, data: { IAdjustmentInfo } }

export const stockControl = {
  /**
   * @param {{ store_id: number,category_id: number,location_id: number }} filter
   * @return {IResponse}
   */
  stockLevel(filter, signal) {
    return businessClient().post('stock/stock-level', { filter }, { signal })
  },

  /**
   * @param {{ store_id: number,item_id: number}} filter
   * @return {IAdjustmentInfoResponse}
   */
  adjustmentInfo(filter, signal) {
    return businessClient().post('stock/adjust-adjustment-info', { filter }, { signal })
  },

  /**
   * @param {{ store_id: number,item_id: number}} data
   * @return {IAdjustmentInfoResponse}
   */
  adjustmentQty(data, signal) {
    return businessClient().post('stock/adjust-qty', { data }, { signal })
  },

  /**
   * @param {{ store_id: number,item_id: number}} data
   * @return {IAdjustmentInfoResponse}
   */
  adjustmentValue(data, signal) {
    return businessClient().post('stock/adjust-value', { data }, { signal })
  },
}
